import React from 'react';
import { rem } from 'polished';
import { css } from '@emotion/react';
import { colors } from '../../../core/styles/theme/default';
import styled from '@emotion/styled';
import Label from './parts/Label';
import {
  EchIconFieldError,
  FmdsIconChevronRight,
} from '../../../primitives/IconSVG';
import FieldError from './parts/FieldError';
import i18n from '../digitID-i18n';

const StyledSelect = styled.div(
  ({ error }: { error?: boolean }) => css`
    position: relative;

    select {
      appearance: none;
      white-space: nowrap;
      text-overflow: ellipsis;
      min-height: ${rem(58)};
      padding: ${rem(11)} ${rem(36)} ${rem(11)} ${rem(16)};

      ${error &&
      css`
        padding-right: ${rem(56)};
      `};
    }
  `,
);

const StyledErrorIcon = styled(EchIconFieldError)`
  position: absolute;
  top: 50%;
  right: ${rem(32)};
  transform: translateY(-50%);
  width: ${rem(16)};
  height: ${rem(16)};
`;

const StyledArrowDown = styled(FmdsIconChevronRight)`
  pointer-events: none;
  position: absolute;
  top: 50%;
  right: ${rem(10)};
  transform: translateY(-50%) rotate(90deg) scale(0.8);
  width: ${rem(18)};
  height: ${rem(18)};

  path {
    stroke: ${colors.black};
  }
`;

const Select = ({
  id,
  label,
  locale,
  value,
  onChange,
  onBlur,
  onFocus,
  error,
  placeholder,
  isRequired,
  isDisabled,
  errorRenderer,
  tooltip,
  options,
}: any) => {
  return options?.length ? (
    <div>
      {label && (
        <Label id={id} tooltip={tooltip} isRequired={isRequired}>
          {label}
        </Label>
      )}
      <StyledSelect error={error}>
        <select
          name={id}
          id={id}
          defaultValue={value || ''}
          placeholder={placeholder}
          disabled={!!isDisabled}
          aria-required={!!isRequired}
          data-error={!!error}
          onChange={(e) => {
            if (typeof onChange === 'function') onChange(e.target.value);
          }}
          onFocus={() => {
            if (typeof onFocus === 'function') onFocus();
          }}
          onBlur={() => {
            if (typeof onBlur === 'function') onBlur();
          }}
        >
          {options.map(({ value, label }: { value: string; label: string }) => (
            <option
              value={value}
              key={value}
              dangerouslySetInnerHTML={{ __html: label }}
            />
          ))}
        </select>
        <StyledArrowDown />
        {error && <StyledErrorIcon />}
      </StyledSelect>
      {error ? (
        errorRenderer ? (
          errorRenderer(error)
        ) : (
          <FieldError text={i18n.requiredField[locale]} />
        )
      ) : null}
    </div>
  ) : null;
};

export const isValid = (value: any, config: any) =>
  config.isRequired && !value ? false : true;

export default Select;
